import { ArrowDropDownCircleSharp } from "@mui/icons-material";
import { Avatar, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Logo from '../../../assets/images/Girlush Logo.png';
import { closeNav, openNav } from "../../../components/hooks/trigger";
import Menu from "./menu";
import { menuData } from "./navItems";
import { useStyle } from "./style";
import { useNavigate } from "react-router-dom";
import DummyMenu from "./dummyMenu";
import axios from "axios";

const SideNav = ({children}) => {
  const classes = useStyle()
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const role_id = localStorage.getItem('role_id')
  const trigger = useSelector((state) => state.trigger);
  const [open, setOpen] = useState(false)
  const [data,setData] = useState([])
  const [loadNavigation , setLoadNavigation] = useState(false)
const menuLoad = useSelector((state) => state.menuLoad)
  const handleSideBar = () =>{
    setOpen(!open)
    if(open){
      dispatch(closeNav())
    }
    else{
      dispatch(openNav())
    }
  }
  function getSideData(){
    axios.get(`v1/menuauth/list/1/${role_id}`)
    .then(res=>{
      console.log(res.data)
      const arr = [...res.data]
      arr.forEach(menu=>{
        menu.submenus.sort((a, b) => a.sub_menu_order - b.sub_menu_order);
      })
     setData(arr)
    })
    .catch(err=>{
      console.log(err.response)
    })
  }
  useEffect(()=>{
if(trigger.isOpen){
  setOpen(true)
}
  },[trigger])

useEffect(()=>{

  if(menuLoad.isOpen ){
    getSideData()
    console.log("first")
    console.log(menuLoad.isOpen)
  }
},[menuLoad.isOpen])
useEffect(() => {
  getSideData()
},[])
// isOpen: !menuLoad.isOpen
  return(
  <Grid className={classes.mainGrid}>
      <Grid className={open ? classes.sideGrid : classes.root}>
<div className="flex items-center justify-center h-14">
<Avatar variant="square" src={Logo} onClick={() => navigate('/dashboard')} sx={{cursor:"pointer"}}/>
 {open &&  <Typography variant="h5" ml={2} onClick={() => navigate('/dashboard')} sx={{cursor:"pointer"}}>GIRLUSH</Typography>}
</div>
    <IconButton  sx={{ transform : open && 'rotate(180deg)'}} className={classes.openIcon} onClick={()=>handleSideBar()}><ArrowDropDownCircleSharp/></IconButton>
    <Grid className={classes.menuGrid}>
    <Menu data={data} flag={open} setFlag={setOpen}/>
    {/* <DummyMenu data={menuData} flag={open} setFlag={setOpen}/> */}

    </Grid>
    </Grid>
    <Grid className={classes.contentGrid}>{children}</Grid>
  </Grid>
  )
};

export default SideNav;
